module.exports = __webpack_public_path__ + "static/img/7.8451124.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/7.jpg
// module id = 7jQq
// module chunks = 0